import React, { useEffect, useRef, useState } from "react";
import ScmModuleStyle from "../styles/scm.module.css";
import Button from "../../common/Button";
import cross from "../assets/cross.png";
import info1 from "../assets/info1.png";
import { useOutletContext } from "react-router-dom";
import { Strategy, initialFactorWeightingData, SupplierDetails } from './Prework-data.js';
import { get_prework, UpdateDataPrework, retry_prework } from '../services/api';
import { index } from "d3";
import { getSession, setSession } from "../../../App";

const Prework = ({from,data}) => {
  const [initialFactorWeighting, setInitialFactorWeighting] = useState(initialFactorWeightingData);

  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location, setError, error, simType, isWaitForMoreBids, setIsWaitForMoreBids, scmPopup, setScmPopup, viewBidsPopup, setViewBidsPopup, setRelaunchPopup, focusPopUp] = useOutletContext();
  const [prework, setPrework] = useState(null)
  const [copyPrework, setCopyPrework] = useState(null)
  const [isSave, setIsSave] = useState(false);
  const [isRetryed, setIsRetryed] = useState(false);
  const [isFactorWeightChanged, setIsFactorWeightChanged] = useState(false);
  const [isRequestLoading,setIsRequestLoading] = useState(false);
  const [changedSuppplierId,setChangedSuppplierId] = useState(null);
  const [isSubmitMsg,setIsSubmitMsg] = useState(false);
  const [isStepsContainerOpen, setIsStepsContainerOpen] = useState(true);
  const [isScenarioContainerOpen, setIsScenarioContainerOpen] = useState(true);
  const [isActivity1Open, setIsActivity1Open] = useState(true);
  const [isActivity2Open, setIsActivity2Open] = useState(true);
  const [isActivity3Open, setIsActivity3Open] = useState(true);
  const isToActivateToaster = useRef(false);
  const [liveMsg, setLiveMsg] = useState('');
  const updatedWeightSupplierId = useRef(null);
  const updatedFactorWeightIndex = useRef(null);
  // const scoreDivRef = useRef(null);
  // const [focusedScoreDiv, setFocusedScoreDiv] = useState(false);
  const preworkStyle = {
    width: "87.5%",
    margin: "auto",
    paddingTop: "15px",
  };

  const handlePopupExitSim = (e) => {
    window.close();
  }

  const getTotalWeightedScore = (supplier) => {
    return supplier?.weightedScore?.reduce( (acc, curr) => {
      if(parseFloat(curr)){
        return acc + parseFloat(curr);
      }
      else{
        return acc;
      }
    }, 0 )
  }

  const activity1TotalWeightedScore = copyPrework?.attemptdata?.strategy?.factorWeight?.reduce((acc, curr) => {
    if(parseFloat(curr)){
      return acc + parseFloat(curr);
    }
    else{
      return acc;
    }
  },0)?.toFixed(1)

  const activity1CriteriaMatched = copyPrework?.attemptdata?.strategy?.factorWeight?.filter(item => parseFloat(item));
  // console.log(activity1CriteriaMatched)
const getFactorWeight = (i) => {
  if(parseFloat(copyPrework?.attemptdata?.strategy?.factorWeight[i])){
    return parseFloat(copyPrework?.attemptdata?.strategy?.factorWeight[i])
  }
  else{
    return 0;
  }
}
  const calculateScore = () => {
    // debugger;
    let score = 0
    if(activity1TotalWeightedScore != 1){
      return 0;
    }
    //If all the activities attempted
    let isSupplier1Changed = Object.values(copyPrework?.attemptdata?.suppliers)[0]?.weightedScore?.filter((weight)=>weight != 0)
    let isSupplier2Changed = Object.values(copyPrework?.attemptdata?.suppliers)[1]?.weightedScore?.filter((weight)=>weight != 0)
    let isSupplier3Changed = Object.values(copyPrework?.attemptdata?.suppliers)[2]?.weightedScore?.filter((weight)=>weight != 0)
    if(activity1TotalWeightedScore == 1 && (isSupplier1Changed.length!=0 || isSupplier2Changed.length!=0 || isSupplier3Changed.length!=0) && copyPrework?.attemptdata?.finalSelectedSupplier){
      score += 10;
    }

    //If one of the top 2 criteria for their product strategy factor rated
    let isTopCriteriaFactorRated = false;

    initialFactorWeighting.forEach((criteria,i)=>{
      if(copyPrework?.attemptdata?.strategy?.topCriterias?.includes(criteria?.id)){
        if(copyPrework?.attemptdata?.strategy?.factorWeight[i] != 0 && !isNaN(parseFloat(copyPrework?.attemptdata?.strategy?.factorWeight[i]))){
          isTopCriteriaFactorRated = true;
        }
      }
    })

    if(isTopCriteriaFactorRated){
      score += 20;
    }

    //Did they weight at least one of the most important things for their strategy most heavily?
    let maxWeight = Math.max(...copyPrework?.attemptdata?.strategy?.factorWeight?.map( (weight) => parseFloat(weight)))
    let mostImpStrategy = false;
    copyPrework?.attemptdata?.strategy?.factorWeight?.forEach((weight, i) => {
      if(weight == maxWeight){
        if(copyPrework?.attemptdata?.strategy?.topCriterias?.includes(initialFactorWeighting[i].id)){
          // score += 20;
          mostImpStrategy = true;
        }
      }
    });
    if(mostImpStrategy){
      score += 20;
    }

    //If supplier1 total weighted score calculated correctly
    if(Object.values(copyPrework?.attemptdata?.suppliers)[0]?.weightedScore?.filter((weight,i)=> parseFloat(weight) != (Object.values(copyPrework?.attemptdata?.suppliers)[0]?.selectedRatingOptions[i]*getFactorWeight(i)).toFixed(1)).length == 0){
      score += 10
    }

    //If supplier2 total weighted score calculated correctly
    if(Object.values(copyPrework?.attemptdata?.suppliers)[1]?.weightedScore?.filter((weight,i)=> parseFloat(weight) != (Object.values(copyPrework?.attemptdata?.suppliers)[1]?.selectedRatingOptions[i]*getFactorWeight(i)).toFixed(1)).length == 0){
      score += 10
    }

    //If supplier3 total weighted score calculated correctly
    if(Object.values(copyPrework?.attemptdata?.suppliers)[2]?.weightedScore?.filter((weight,i)=> parseFloat(weight) != (Object.values(copyPrework?.attemptdata?.suppliers)[2]?.selectedRatingOptions[i]*getFactorWeight(i)).toFixed(1)).length == 0){
      score += 10
    }

    //if highest weighted supplier selected
    if(copyPrework?.attemptdata?.finalSelectedSupplier && getMaxWeightedSupplier().includes(copyPrework?.attemptdata?.finalSelectedSupplier)){
      score += 20
    }
    return score
  }  

  // useEffect(()=>{
  //   if(copyPrework?.attemptdata?.suppliers){
  //     calculateScore();
  //   }
  // },[copyPrework?.attemptdata?.suppliers])
  const submitPrework = () => {
    // setFocusedScoreDiv(true);
    if(parseFloat(activity1TotalWeightedScore) != 1){
      setIsSubmitMsg(true);
      return;
    }
    setCopyPrework((prevCopyPrework)=>(
      {
      ...prevCopyPrework,
      ['completed'] : 1,
      ['score'] : calculateScore()
      }
    ));
    // setIsSave(true);
    setTimeout(() => {
      window.$("#preworkScoreBlock").attr("tabindex","-1").focus();
    }, 2000);
  }

  const removeItem = (array, index) => {
    return array.slice(0, index).concat(array.slice(index + 1));
  }
  const setInitialData = () => {

    // window.$('.ui.dropdown').dropdown('clear');
    // document.querySelector(".ui.dropdown .text").textContent = "Select"

    //selecting random suppliers
    let remainingSuppliers = SupplierDetails.slice();
    const suppliers = {}

    const firstIndex = Math.floor(Math.random() * remainingSuppliers.length);
    // suppliers.push(remainingSuppliers[firstIndex]);
    suppliers[remainingSuppliers[firstIndex].supplierId] = remainingSuppliers[firstIndex]
    remainingSuppliers = removeItem(remainingSuppliers, firstIndex);

    const secondIndex = Math.floor(Math.random() * remainingSuppliers.length);
    // suppliers.push(remainingSuppliers[secondIndex]);
    suppliers[remainingSuppliers[secondIndex].supplierId] = remainingSuppliers[secondIndex]
    remainingSuppliers = removeItem(remainingSuppliers, secondIndex);

    const thirdIndex = Math.floor(Math.random() * remainingSuppliers.length);
    // suppliers.push(remainingSuppliers[thirdIndex]);
    suppliers[remainingSuppliers[thirdIndex].supplierId] = remainingSuppliers[thirdIndex]

    //Selecting strategy
    const randomIndex = Math.floor(Math.random() * Strategy.length);
    const randomStrategy = Strategy[randomIndex];

    window.$("html, body").animate(
      {
        scrollTop: 0,
      },
      100
    );

    setCopyPrework((prev) => ({
      ...prev,
      attemptdata: {
        ['suppliers']: suppliers,
        ['strategy']: randomStrategy
      }
    }))
    setIsSave(true);
  }

  const getPrework = () => {
    if(!isRequestLoading){
      setIsRequestLoading(true);
      get_prework().then((response) => {
        if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
          // setError(response?.data)
        }
        else {
          if (typeof response != 'undefined') {
            setPrework(response?.data);
            setCopyPrework(response?.data)
            setIsLoader(false);
            setIsRequestLoading(false);
          }
        }
      }).catch((error) => {
        console.log(error);
      })
    }
  }

  const updatePrework = () => {
    if(!isRequestLoading){
      setIsRequestLoading(true);
      setTimeout(() => {
        if (copyPrework != {}) {
          UpdateDataPrework(copyPrework).then((response) => {
            if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
              setError(response?.data)
            }
            else {
              if (typeof response != 'undefined') {
                if(isToActivateToaster.current){
                  isToActivateToaster.current = false;
                  window.$('#saveToaster').show().transition('fade in');
                    document.querySelector("#saveToaster").setAttribute("aria-hidden","false");

                    // Hide the message after 5 seconds
                    setTimeout(function() {
                      window.$('#saveToaster').transition('fade out').hide();
                      document.querySelector("#saveToaster").setAttribute("aria-hidden","true")
                    }, 3000);
                }
                setPrework(response?.data);
                setIsSave(false);
                setCopyPrework(response?.data);
                setIsRequestLoading(false);
              }
            }
          }).catch((error) => {
            console.log(error);
          })
        }
      }, 100)
    }
  }

  const resetPrework = () => {
    setTimeout(() => {
      if (copyPrework != {}) {
          setIsRetryed(true);
          retry_prework(copyPrework.sessionid).then((response) => {
              if (response.status === 500 && response?.data?.hasOwnProperty("id") && response?.data?.hasOwnProperty("msg")) {
                  setError(response?.data)
              }
              else {
                  if (typeof response != 'undefined' ) {
                      // setPrework(response?.data);
                      if(response.status === 200){
                          getPrework();
                      }
                  }
              }
          }).catch((error) => {
              // setError("Only instructor can change settings.");
              //setError({"id":"00000","msg":"Only instructor can change settings."})
              console.log(error);
          })
      }
  }, 100)
  }

  const updateSelectedOptions = (e,index,supplierId) => {
    setChangedSuppplierId(supplierId);
    let prevSelectedOptions = copyPrework?.attemptdata?.suppliers[supplierId]?.selectedRatingOptions
    prevSelectedOptions[index] =  Number(e.target.getAttribute("data-value"))
    setCopyPrework((prevCopyPrework)=>(
      {
        ...prevCopyPrework,
        attemptdata : {
          ...prevCopyPrework.attemptdata,
          suppliers : {
            ...prevCopyPrework.attemptdata.suppliers,
            [supplierId] : {
              ...prevCopyPrework.attemptdata.suppliers[supplierId],
              selectedRatingOptions : prevSelectedOptions
            }
          }
        }
      }
    ))
    // setIsSave(true);
  }

  const setFinalSelectedSupplier = (e) => {
    setCopyPrework((prevCopyPrework)=>(
      {
        ...prevCopyPrework,
        attemptdata : {
          ...prevCopyPrework.attemptdata,
          ['finalSelectedSupplier'] : e.target.querySelectorAll("option")[e.target.selectedIndex].getAttribute("data-supplierId")
        }
      }
    ))
    // setIsSave(true);
  }

  // const getMaxWeightedSupplier = () => {
  //   return Object.values(copyPrework?.attemptdata?.suppliers)?.sort((a, b) => getTotalWeightedScore(b) - getTotalWeightedScore(a))[0]?.supplierId;
  // }

  const getMaxWeightedSupplier = () => {
    const suppliers = Object.values(copyPrework?.attemptdata?.suppliers);
    
    if (!suppliers || suppliers.length === 0) {
      return [];
    }
  
    // Find the maximum weighted score among suppliers
    const maxWeightedScore = Math.max(...suppliers.map(supplier => getTotalWeightedScore(supplier).toFixed(1)));
  
    // Filter suppliers that have the maximum weighted score
    const maxSuppliers = suppliers.filter(supplier => parseFloat(getTotalWeightedScore(supplier).toFixed(1)) === maxWeightedScore);
  
    // Return the IDs of these suppliers
    return maxSuppliers.map(supplier => supplier.supplierId);
  };
  
  const handleArrowKeyNavigation = (e, currentIndex, supplierId) => {
    const radioButtons = document.querySelectorAll(`input[name='radio-${supplierId}-${currentIndex}']`);
    const currentIndexInGroup = Array.from(radioButtons).indexOf(e.target);
  
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
      const nextIndex = (currentIndexInGroup + 1) % radioButtons.length;
      radioButtons[nextIndex].focus();
      radioButtons[nextIndex].checked = true;
      // Trigger any onChange or click events as needed
      radioButtons[nextIndex].click();
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
      const prevIndex = (currentIndexInGroup - 1 + radioButtons.length) % radioButtons.length;
      radioButtons[prevIndex].focus();
      radioButtons[prevIndex].checked = true;
      // Trigger any onChange or click events as needed
      radioButtons[prevIndex].click();
    }
    else if(e.key == "Enter"){
      radioButtons[currentIndexInGroup].click();
    }
  }
  
const checkDropdownClass = (e) => {
    if(e.target.classList.contains(`${ScmModuleStyle.visible}`)){
      e.target.classList.remove(`${ScmModuleStyle.visible}`)
    }
    else{
      e.target.classList.add(`${ScmModuleStyle.visible}`)
    }
}

const checkKey = (event) => {
  if (event.type == "keydown" && /Android|iPad/i.test(navigator.userAgent)) {
    return
  }
  let key = ""
  if(event.type == "keydown" && event.key && event.key != "unidentified"){
    key = event.key;
  }
  if(event.type == "input" && event.data && event.data != "")
  {
    key = event.data[event.data.length-1]
  }
    // Allow control keys: backspace, delete, arrow keys, etc.
    const controlKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight','ArrowUp','ArrowDown', 'Tab'];
          
    // Allow only one decimal point
    const isDecimalPoint = key === '.' && !event.target.value.includes('.');

    if (
      !controlKeys.includes(key) && // Allow control keys
      !(key >= '0' && key <= '9') && // Allow number keys
      !isDecimalPoint // Allow one decimal point
    ) {
      if(event.type == "input" && event.data){
        event.target.value = event.target.getAttribute("data-value")
      }
      else{
        event.preventDefault();
      }
      return ;
    }
    // if(event.type == "input"){
    //   updateFactorWeight(event)
    // }
}

const updateFactorWeight = (e,index) => {
  setIsSubmitMsg(false);
  if(e.target.value != ""){
    let value = e.target.value
    if(parseFloat(value < 0) || parseFloat(value)>1 || !/^(\d(\.\d{1})?)?$/.test(value)){
      return ;
    }
    // let value = parseFloat(e.target.value)
    // if(value < 0 || value>1 || !/^(\d+(\.\d{1})?)?$/.test(value)){
    //   return ;
    // }
  }
  // setIsFactorWeightChanged(true);
  updatedFactorWeightIndex.current = index;
  setCopyPrework((prevCopyPrework)=>(
    {
      ...prevCopyPrework,
      attemptdata : {
        ...prevCopyPrework.attemptdata,
        ['strategy'] : {
          ...prevCopyPrework.attemptdata.strategy,
          ['factorWeight'] : [...prevCopyPrework?.attemptdata?.strategy?.factorWeight].map((item,i)=>{
            if(i === index){
              return e.target.value
            }
            else{
              return item
            }
          })
        }
      }
    }
  ))
}

const updateSupplierFactorWeight = (e,supplier,index) => {
  if(e.target.value != ""){
    let value = e.target.value
    if(parseFloat(value) > 50 || !/^\d{0,2}(\.\d)?$/.test(value)){
      return ;
    }
  }
  updatedWeightSupplierId.current = supplier.supplierId;
  setCopyPrework((prevCopyPrework)=>(
    {
      ...prevCopyPrework,
      attemptdata : {
        ...prevCopyPrework.attemptdata,
        ['suppliers'] : {
          ...prevCopyPrework.attemptdata.suppliers,
          [supplier.supplierId] : {
            ...prevCopyPrework.attemptdata.suppliers[supplier.supplierId],
            ['weightedScore'] : [...prevCopyPrework.attemptdata.suppliers[supplier.supplierId].weightedScore].map((item,i)=>{
              if(i === index){
                return e.target.value
              }
              else{
                return item
              }
            })
          }
        }
      }
    }
  ))
}

useEffect(() => {
  if(updatedFactorWeightIndex.current !== null && copyPrework?.attemptdata?.strategy?.factorWeight ){
    setLiveMsg(`Updated total weighted score is ${activity1TotalWeightedScore}`);
    updatedFactorWeightIndex.current = null;
  }
  if(updatedWeightSupplierId.current !== null && copyPrework?.attemptdata?.suppliers){
    let supplier = copyPrework?.attemptdata?.suppliers?.[updatedWeightSupplierId.current];
    setLiveMsg(`Updated ${supplier?.weightedScoreText} is ${getTotalWeightedScore(supplier)?.toFixed(1)}`);
    updatedWeightSupplierId.current = null;
  }
},[copyPrework?.attemptdata?.strategy?.factorWeight, copyPrework?.attemptdata?.suppliers]);

useEffect(()=>{
    if(isRetryed){
      setIsRetryed(false);
      if(document.querySelector("header.header h1")){
        document.querySelector("header.header h1").setAttribute("tabindex","-1");
        document.querySelector("header.header h1").focus();
      }
      window.$("html, body").animate(
        {
          scrollTop: 0,
        },
        100
      );
    }
},[isRetryed])

  useEffect(() => {
    let artifactSel = document.querySelector(".artifacts");
    let OverlaySel = document.querySelector("#overlay");
    let ApprowSel = document.querySelector(".App .row");
    let FooterIntro = document.querySelector('.footer-nav .footer-links .listitem');
    setIsArtifacts(false);
    window.$(".ui.accordion").accordion();
    // window.$('.ui.dropdown').dropdown();
    document.querySelector(".supplier-dropdown").addEventListener("change",setFinalSelectedSupplier)
    window.$("html, body").animate(
      {
        scrollTop: 0,
      },
      100
    );
    document.title = "Supply Chain Management | Prework";
    if (artifactSel !== null) {
      artifactSel.style.display = "none";
    }
    // if (OverlaySel !== null) {
    //   OverlaySel.style.display = "none";
    // }
    setIsOverlay(false);
    if (ApprowSel !== null) {
      ApprowSel.style.minHeight = "auto";
      ApprowSel.style.minHeight = "100vh";
    }
    if (FooterIntro !== null) {
      FooterIntro.style.display = "none"; //for hide intro navigation
    }
    document.querySelector(".title").textContent =
      "Supply Chain Management - Prework";
      // let localsid = localStorage.getItem("session_id") != null ? localStorage.getItem("session_id") : "";
      //   let sessionId = (window.location.hash != "") ? 
      //   (((window.location.hash != "") && (window.location.hash.split("#")[1].length > 20)) ? window.location.hash.split("#")[1] : localsid) : localsid;
      //   if (sessionId != "") {
      //       localStorage["session_id"] = sessionId;
      //       getPrework();
      //   }
      if(document.querySelector("header.header h1")){
        document.querySelector("header.header h1").setAttribute("tabindex","-1");
        document.querySelector("header.header h1").focus();
      }
    
    return ()=> {
      if(document.querySelector(".supplier-dropdown")){
        document.querySelector(".supplier-dropdown").removeEventListener("change",setFinalSelectedSupplier)
      }
    }
  }, []);

  useEffect(()=>{
    if(from && from=="preworkdecisionhistory" && data){
        setPrework(data);
        setCopyPrework(data);
      if(document.querySelector(".footer")){
        document.querySelector(".footer").style.display = "block";
      }
      if(document.querySelector(".sv-components-column.sv-components-container-contentBottom")){
        document.querySelector(".sv-components-column.sv-components-container-contentBottom").style.display = "none";
      }
    }
    else{
      let localsid = getSession() != null ? getSession() : "";
          let sessionId = (window.location.hash != "") ? 
          (((window.location.hash != "") && (window.location.hash.split("#")[1].length > 20)) ? window.location.hash.split("#")[1] : localsid) : localsid;
  
          if (sessionId != "") {
              setSession(sessionId);
              getPrework();
          }
    }
  },[from,data])
  
  useEffect(() => {
    if (Array.isArray(prework?.attemptdata) && prework?.attemptdata?.length == 0) {
      setInitialData();
    }
  }, [prework]);

  // const disableDropdown = () => {
    
  //   if(document.querySelector(".ui.dropdown .text") && !document.querySelector(".ui.dropdown .text .sr-only")){
  //     // Create a new span element
  //   const span1 = document.createElement('span');
  //   const srSpan = document.createElement('span');
    
  //   // Add the sr-only class to the span

  //   srSpan.className = 'sr-only';
    
  //   // Set the text content for the span
  //   srSpan.innerHTML = `${document.querySelector(".ui.dropdown .text").textContent} disabled`;
  //   span1.setAttribute("aria-hidden","true");


  //   span1.innerHTML = `${document.querySelector(".ui.dropdown .text").textContent}`;
  //   document.querySelector(".ui.dropdown .text").innerHTML = ""
    
  //   document.querySelector(".ui.dropdown .text").appendChild(span1);
  //   document.querySelector(".ui.dropdown .text").appendChild(srSpan);

  //   // document.querySelector(".ui.dropdown .text").setAttribute("aria-describedby","mySpan")
  //   }
  // }

  // const enableDropdown = () => {
  //   let content = "Select"
  //   if(document.querySelector(".ui.dropdown .text span")){
  //     content = document.querySelector(".ui.dropdown .text span").textContent;
  //   }
  //   else{
  //     content = document.querySelector(".ui.dropdown .text").textContent;
  //   }
  //   document.querySelector(".ui.dropdown .text").innerHTML = content;
  // }

  // useEffect(()=>{
  //   if(copyPrework?.completed || !(copyPrework?.mode == "do" || copyPrework?.mode == "preview") || (activity1TotalWeightedScore != 1) || (activity1CriteriaMatched.length < 4)){
  //     disableDropdown();
  //   }
  // }, [copyPrework,copyPrework?.attemptdata])

  // useEffect(()=>{
  //   if((activity1TotalWeightedScore == 1) && (activity1CriteriaMatched.length == 4) && (copyPrework?.completed != 1)){
  //     enableDropdown();
  //   }
  // },[copyPrework?.completed,copyPrework?.attemptdata])

  useEffect(() => {
    isSave && updatePrework();
  }, [isSave])

  useEffect(()=>{
    if(copyPrework?.completed && !(prework?.completed)){
      setIsSave(true);
    }
  },[copyPrework?.completed,prework?.completed])

  useEffect(()=>{
    if(copyPrework?.attemptdata){
      let visibleCriterias = copyPrework?.attemptdata?.strategy?.factorWeight?.filter((item)=>item != 0).length
      if(activity1TotalWeightedScore != 1 || copyPrework?.completed || activity1CriteriaMatched.length < 4){
        document.querySelector(".supplier-dropdown").classList.add(`disabled`);
        document.querySelector(".supplier-dropdown").setAttribute("tabindex","-1");
        document.querySelector(".supplier-dropdown").classList.remove(`${ScmModuleStyle.enabled}`)
      }
      else{
        document.querySelector(".supplier-dropdown").classList.add(`${ScmModuleStyle.enabled}`);
        document.querySelector(".supplier-dropdown").setAttribute("tabindex","0");
        document.querySelector(".supplier-dropdown").classList.remove(`disabled`)
      }
    }
  },[copyPrework?.attemptdata])

  useEffect(()=>{
    let inputs = document.getElementsByClassName(`${ScmModuleStyle["inputFields"]}`)
    if(inputs && inputs?.length>0){
      Array.from(inputs).forEach((inp)=>{
        inp.addEventListener("keydown",checkKey);
        if (/Android|iPad/i.test(navigator.userAgent)) {
          inp.addEventListener("input",checkKey);
        } 
      })
    }

    // return () => {
    //   let inputs = document.getElementsByClassName(`${ScmModuleStyle["inputFields"]}`)
    //   if(inputs && inputs?.length>0){
    //     Array.from(inputs).forEach((inp)=>{
    //       inp.removeEventListener("keydown",checkKey);
    //       inp.removeEventListener("input",checkKey);
    //     })
    // }
    // }
  },[initialFactorWeighting,copyPrework?.attemptdata?.suppliers])

  useEffect(()=>{
    if(!headerPopup || !isOverlay){
        setTimeout(() => {
            Array.from(document.querySelectorAll(".showBtn")).map((item)=>{
                item.setAttribute("tabindex","-1")
            })
        }, 100);
    }
  },[headerPopup,isOverlay])

  // useEffect(() => {
  //   if (prework?.completed && prework?.hasOwnProperty('score') && scoreDivRef.current && focusedScoreDiv) {
  //       scoreDivRef.current.focus();
  //       setFocusedScoreDiv(false);
  //   }
  //   }, [prework, focusedScoreDiv]);

  return (
    <div className="scmprework prework container" style={preworkStyle}>
      <div className={`${ScmModuleStyle.introtext} ${ScmModuleStyle["mbottom"]}`}>
        <div className={`ui accordion ${ScmModuleStyle["ui"]} ${ScmModuleStyle["accordion"]} ${ScmModuleStyle["prework-tables"]}`}>
                      <div className={`title ${isStepsContainerOpen ? "active" : ""} ${ScmModuleStyle["title"]}`}
                          onClick={()=>{
                              setIsStepsContainerOpen(prev => !prev)
                          }}
                          >
                        <h2 id="stepsHeading" className={`${ScmModuleStyle["intro-heading"]} ${ScmModuleStyle["step-heading"]}`}>
                          <span>Steps</span>
                          <button className='chevron-btn' aria-expanded={isStepsContainerOpen} aria-labelledby="stepsHeading">
                              {
                                isStepsContainerOpen ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                                : <i className={`chevron down icon`} aria-hidden="true"></i>
                              }
                          </button>
                        </h2>
                      </div>
                      <div className={`content ${isStepsContainerOpen ? "active" : ""}`}>
                        <ol className={`${ScmModuleStyle["custom-list-ol"]}`}>
              <li>
                Read scenario and approach.
              </li>
              <li>
                Learn about your product strategy that guides how your product wins in the market:
                <ol className={`${ScmModuleStyle["sublist"]}`} type="a">
                  <li>Do you offer the cheapest pens that get the job done?</li>
                  <li>Do you offer great delivery service, quicker than the competition?</li>
                  <li>Do you offer unique, quality pens?</li>
                </ol>
              </li>
              <li>
                In Activity 1, fill out the table to identify the weight of each factor for your suppliers. The overall weight must add up to 1.0 and you must rate at least 4 factors.
              </li>
              <li>
                In Activity 2, use the available information for the 3 different suppliers to get an overall weighted score. Do this by multiplying your Weight Factor by the Rating Score.
              </li>
              <li>
                In Activity 3, compare the overall weighted scores and choose your top supplier choice for ordering ink.
              </li>
              <li>
              <div>
                Click the <div style={{'display': 'inline-block'}}><span className={`${ScmModuleStyle["custom-button"]} ${ScmModuleStyle["save-customBtn"]}`}>Save</span></div> button to keep your progress. Once you’ve finished the assignment, click the <div style={{'display': 'inline-block'}}><span className={`${ScmModuleStyle["custom-button"]} ${ScmModuleStyle["submit-customBtn"]}`}>Submit</span></div> button to receive your grade and feedback.
              </div>
            </li>
                        </ol>
                      </div>
        </div>
      </div>
      <div className={`${ScmModuleStyle.introtext} ${ScmModuleStyle["mbottom"]}`}>
        <div className={`ui accordion ${ScmModuleStyle["ui"]} ${ScmModuleStyle["accordion"]} ${ScmModuleStyle["prework-tables"]}`}>
          <div className={`title ${isScenarioContainerOpen ? "active" : ""} ${ScmModuleStyle["title"]}`}
              onClick={()=>{
                  setIsScenarioContainerOpen(prev => !prev)
              }}
              >
                  <h2 id="scenarioHeading" className={`${ScmModuleStyle["intro-heading"]}`}>
                    <span>Scenario</span>
                    <button className='chevron-btn' aria-expanded={isScenarioContainerOpen} aria-labelledby="scenarioHeading">
                        {
                          isScenarioContainerOpen ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                          : <i className={`chevron down icon`} aria-hidden="true"></i>
                        }
                    </button>
                  </h2>
          </div>
          <div className={`content ${ScmModuleStyle.content} ${isScenarioContainerOpen ? "active" : ""}`}>
            <p className={`${ScmModuleStyle["indent-para"]}`}>You are the owner of a company focused on making pens. You specialize in the final assembly of your pens, but you need to partner with a supplier to manufacture the ink to construct your pens.</p>
            <p>You need to select the best supplier to help you achieve your product strategy. Depending on your product strategy, you will weigh different supplier factors differently. This will cause you to ultimately select a different supplier to work with.</p>
          </div>
      </div>
      </div>
      <div className={`${ScmModuleStyle.introtext} ${ScmModuleStyle.activity1} ${ScmModuleStyle["mbottom"]}`}>
        <h2 className={`${ScmModuleStyle["intro-heading"]}`}>Approach</h2>
        <div className={`ui accordion ${ScmModuleStyle["ui"]} ${ScmModuleStyle["accordion"]} ${ScmModuleStyle["prework-tables"]}`}>
          <div className={`title ${isActivity1Open ? "active" : ""} ${ScmModuleStyle["title"]}`}
              onClick={()=>{
                  setIsActivity1Open(prev => !prev)
              }}
              >
                  <h2 id="activity1Heading" className={`${ScmModuleStyle["intro-heading"]}`}>
                    <span>Activity 1: Factor Weighting</span>
                    <button className='chevron-btn' aria-expanded={isActivity1Open} aria-labelledby="activity1Heading">
                        {
                          isActivity1Open ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                          : <i className={`chevron down icon`} aria-hidden="true"></i>
                        }
                    </button>
                  </h2>
          </div>
          <div className={`content ${ScmModuleStyle.content} ${isActivity1Open ? "active" : ""}`}>
            <p className={`${ScmModuleStyle["strategy-text"]}`}>Your Product Strategy is: <strong className={`${ScmModuleStyle["strategy-selction"]}`}>{copyPrework?.attemptdata?.strategy?.name}</strong></p>
            <p className={`${ScmModuleStyle["indent-para"]}`}>Here are the different Factors for you to weight based on your product strategy. Be sure to weight at least four different factors with at least 0.1. Your final total must add you to 1.0. The most important factors based on your product strategy should be weighted highest.</p>
            <div className="sr-only" aria-live="assertive">{liveMsg}</div>
            <div className={`ui container ${ScmModuleStyle["ui"]} ${ScmModuleStyle["container"]} ${ScmModuleStyle["prework-table-container"]}`}>
              <table className={`ui unstackable celled table ${ScmModuleStyle["ui"]} ${ScmModuleStyle["table"]}`}>
                <thead>
                  <tr>
                    <th scope="col" className="center aligned">Criteria</th>
                    <th scope="col" className="center aligned">Factor Weight (between 0.1 and 1.0). Needs to equal 1.0</th>
                  </tr>
                </thead>
                <tbody>
                  {initialFactorWeighting?.map((item, index) => (
                    <tr key={index}>
                      <td scope="row" dangerouslySetInnerHTML={{ __html: item.criteria }} />
                      <td className="center aligned">
                        <input data-value={copyPrework?.attemptdata?.strategy?.factorWeight[index]} data-index={index} type="number" className={`${ScmModuleStyle["inputFields"]}`} min={0} max={1} step={0.1} value={copyPrework?.attemptdata?.strategy?.factorWeight[index]} onChange={(e)=>{
                          updateFactorWeight(e,index)
                        }
                        } disabled={copyPrework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")}/>
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td scope="row">TOTAL WEIGHT SCORE</td>
                    <td className="center aligned">
                      <strong>{activity1TotalWeightedScore}</strong>
                      {/* <div className="sr-only" aria-live="assertive">{`Updated total weighted score is ${activity1TotalWeightedScore}`}</div> */}
                      {
                        (activity1TotalWeightedScore!= 1 || activity1CriteriaMatched.length < 4) ? <div className={`ui message ${ScmModuleStyle.ui} ${ScmModuleStyle.message}`}>
                          <div role='alert' aria-live="assertive">
                            { 
                              <><img src={info1} alt="info" height={22}/>
                              {
                                (activity1TotalWeightedScore!= 1) ? <p>{`The total weighted score needs to equal 1.`}</p>  : <p>You must factor weight at least four criterias.</p>

                              }   
                              </>
                            }
                          </div>
                        </div>
                        : ""
                      }
                      
                      </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
      </div>
        
      </div>
      <div className={`${ScmModuleStyle.introtext} ${ScmModuleStyle.activity2} ${ScmModuleStyle["mbottom"]}`}>
        <div className={`ui accordion ${ScmModuleStyle["ui"]} ${ScmModuleStyle["accordion"]} ${ScmModuleStyle["prework-tables"]}`}>
            <div className={`title ${isActivity2Open ? "active" : ""} ${ScmModuleStyle["title"]}`}
                onClick={()=>{
                    setIsActivity2Open(prev => !prev)
                }}
                >
                    <h2 id="activity2Heading" className={`${ScmModuleStyle["intro-heading"]}`}>
                      <span>Activity 2: Supplier Analysis</span>
                      <button className='chevron-btn' aria-expanded={isActivity2Open} aria-labelledby="activity2Heading">
                          {
                            isActivity2Open ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                            : <i className={`chevron down icon`} aria-hidden="true"></i>
                          }
                      </button>
                    </h2>
            </div>
            <div className={`content ${ScmModuleStyle.content} ${isActivity2Open ? "active" : ""}`}>
              <p className={`${ScmModuleStyle["indent-para"]}`}>Use the available information for the three different suppliers, plus your Factor Weight, to arrive at a Weighted Score per criteria, and for the Overall Weighted Score for that supplier.</p>
              <p className={`${ScmModuleStyle["indent-para-act2"]}`}>Fill out the Weighted Score in each row of each table by multiplying the assigned Factor Weights by the Rating Scores. Then compute the total Weighted Score for that supplier. Do this for all three suppliers.</p>
                {
                  copyPrework?.attemptdata?.suppliers && Object?.values(copyPrework?.attemptdata?.suppliers)?.map((supplier, index) => {
                    return (
                      <div className={`${ScmModuleStyle["supplier-block"]}`}>
                        <h3 className={`${ScmModuleStyle["table-heading"]}`}><strong>SUPPLIER {index+1} ANALYSIS:</strong></h3>
                        <div className={`ui container ${ScmModuleStyle["ui"]} ${ScmModuleStyle["container"]} ${ScmModuleStyle["prework-table-container"]}`}>
                          <table className={`ui unstackable celled table ${ScmModuleStyle["ui"]} ${ScmModuleStyle["table"]} ${ScmModuleStyle["supplier-table"]}`}>
                            <thead>
                              <tr>
                                <th>Supplier</th>
                                <th>Weekly Delivery</th>
                                <th>Years in Service</th>
                                <th>Bid Cost</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>{supplier?.supplierName}</td>
                                <td>{supplier?.weeklyDelivery}</td>
                                <td>{supplier?.yearsInService}</td>
                                <td>${supplier?.bidCost}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <h4 className={`${ScmModuleStyle["price-info-text"]}`}><strong>Pricing Information:</strong></h4>
                        <div className={`ui container ${ScmModuleStyle["ui"]} ${ScmModuleStyle["container"]} ${ScmModuleStyle["prework-table-container"]}`}>
                          <table className={`ui unstackable celled table ${ScmModuleStyle["ui"]} ${ScmModuleStyle["table"]} ${ScmModuleStyle["pricing-table"]}`}>
                            {/* <thead> */}
                              <tr>
                                <th>Number of Units</th>
                                {
                                  supplier?.numberOfUnits?.map((item, index) => <td key={index}>{item}</td>)
                                }
                              </tr>
                              <tr>
                                <th>Per Unit Price</th>
                                {
                                  supplier?.perUnitPrice?.map((item, index) => <td key={index}>${item}</td>)
                                }
                              </tr>
                            {/* </thead> */}
                          </table>
                        </div>
                        <p className={`${ScmModuleStyle["rating-text"]}`}><strong>Rating Scale: </strong><span className={`${ScmModuleStyle["dashed-line"]}`}>1-5 (5 Highest)</span></p>
                        <div className={`ui container ${ScmModuleStyle["ui"]} ${ScmModuleStyle["container"]} ${ScmModuleStyle["prework-table-container"]}`}>
                          <table className={`ui unstackable celled table ${ScmModuleStyle["ui"]} ${ScmModuleStyle["table"]}`}>
                            <thead>
                              <tr>
                                <th scope="col" className="center aligned">Criteria</th>
                                <th scope="col" className="center aligned">5</th>
                                <th scope="col" className="center aligned">4</th>
                                <th scope="col" className="center aligned">3</th>
                                <th scope="col" className="center aligned">2</th>
                                <th scope="col" className="center aligned">1</th>
                                <th scope="col" className="center aligned">Factor Weight</th>
                                <th scope="col" className="center aligned">Weighted Score</th>
                              </tr>
                            </thead>
                            <tbody>
                              {initialFactorWeighting?.map((item, currentIndex) => (
                                // (copyPrework?.attemptdata?.strategy?.factorWeight[currentIndex]) != 0 ? 
                                <tr key={currentIndex}>
                                  <td scope="row" dangerouslySetInnerHTML={{ __html: item.criteria }}></td>  
                                  {
                                    new Array(5).fill("")?.map((item,index)=>{
                                      return (
                                        <td className={`${ScmModuleStyle.crossImgTd}`}>
                                          {/* <input
                                            type="radio"
                                            name={`radio-${supplier?.supplierId}-${currentIndex}`}
                                            data-value={5-index}
                                            // onClick={(e)=> updateSelectedOptions(e,currentIndex,supplier?.supplierId)}
                                            // onKeyDown={(e) => handleArrowKeyNavigation(e, currentIndex, supplier?.supplierId)}
                                            checked = {supplier?.selectedRatingOptions?.[currentIndex] === 5-index}
                                            // disabled = {(copyPrework?.completed) || (copyPrework?.status == "COMPLETED") || isRequestLoading || !(prework?.mode == "do" || prework?.mode == "preview")}
                                            disabled={true}
                                          /> */}

                                          {
                                          supplier?.selectedRatingOptions?.[currentIndex] === 5-index ? <><span className="sr-only">rating {5-index} available</span><img src={cross} width={20} aria-hidden="true"/></> : <span className="sr-only">rating {5-index} unavailable</span>
                                          }
                                        </td>
                                      )
                                    })
                                  }
                                  <td className="center aligned">{copyPrework?.attemptdata?.strategy?.factorWeight[currentIndex]}</td>
                                  <td className={`center aligned`}>
                                    <div className={`${ScmModuleStyle.dflex}`}>
                                      <input data-value={supplier?.weightedScore?.[currentIndex]} data-index={currentIndex} type="number" disabled={activity1TotalWeightedScore != 1 || copyPrework?.completed || activity1CriteriaMatched?.length < 4} className={`${ScmModuleStyle["inputFields"]}`} min={0} step={0.1} value={supplier?.weightedScore?.[currentIndex]} onChange={(e)=>updateSupplierFactorWeight(e,supplier,currentIndex)}/>
                                      {
                                        copyPrework?.completed ? 
                                        ( ((parseFloat(activity1TotalWeightedScore) == 1) && (parseFloat(supplier?.weightedScore?.[currentIndex]) == parseFloat(copyPrework?.attemptdata?.strategy?.factorWeight[currentIndex]*supplier?.selectedRatingOptions?.[currentIndex]).toFixed(1)))
                                          ? <span className={`${ScmModuleStyle["correct-sign"]}`}>
                                            <span className="sr-only">correct weighted score</span>
                                          </span>
                                          : <span className={`${ScmModuleStyle["incorrect-sign"]}`}>
                                            <span className="sr-only">incorrect weighted score</span>
                                          </span>
                                        ) 
                                        : ""
                                      }
                                    </div>
                                  </td>
                                </tr>
                                // : 
                                // ""
                              ))}
                            </tbody>
                          </table>
                        </div>
                        <p className={`${ScmModuleStyle["rating-text"]}`}><strong>{supplier?.weightedScoreText}</strong>
                          <span className={`${ScmModuleStyle["dashed-line"]}`}>
                          {/* 1.0 */}
                          {getTotalWeightedScore(supplier)?.toFixed(1)}
                          </span>
                        </p>
                        {/* <div className="sr-only" aria-live="assertive">{`Updated ${supplier?.weightedScoreText} is ${getTotalWeightedScore(supplier)?.toFixed(1)}`}</div> */}
                      </div>
                    )
                  })
                }
            </div>
        </div>
      </div>
      <div className={`${ScmModuleStyle.introtext} ${ScmModuleStyle.activity3} ${ScmModuleStyle["mbottom"]}`}>
        <div className={`ui accordion ${ScmModuleStyle["ui"]} ${ScmModuleStyle["accordion"]} ${ScmModuleStyle["prework-tables"]}`}>
            <div className={`title ${isActivity3Open ? "active" : ""} ${ScmModuleStyle["title"]}`}
                onClick={()=>{
                    setIsActivity3Open(prev => !prev)
                }}
                >
                    <h2 id="activity3Heading" className={`${ScmModuleStyle["intro-heading"]}`}>
                      <span>Activity 3: Supplier Selection</span>
                      <button className='chevron-btn' aria-expanded={isActivity3Open} aria-labelledby="activity3Heading">
                          {
                            isActivity3Open ?   <i className={`chevron up icon`} aria-hidden="true"></i>
                            : <i className={`chevron down icon`} aria-hidden="true"></i>
                          }
                      </button>
                    </h2>
            </div>
            <div className={`content ${ScmModuleStyle.content} ${isActivity3Open ? "active" : ""}`}>
              <p className={`${ScmModuleStyle["para-text"]}`}>Identify which supplier you will choose to work with based on their final Weighted Score: </p>
              <div className={`${ScmModuleStyle["supplier-choice"]}`}>
                <div>
                {/* <span id="supplierLabel"><strong>Top Supplier Choice: </strong></span>
                <select className={`ui dropdown ${ScmModuleStyle["ui"]} ${ScmModuleStyle["dropdown"]}`} aria-labelledby="supplierLabel" >
                  <option value="" selected={!copyPrework?.attemptdata?.finalSelectedSupplier} aria-label="Select">Select</option>
                  {
                    copyPrework?.attemptdata?.suppliers && Object.values(copyPrework?.attemptdata?.suppliers)?.map((item, i) => 
                    <option 
                    key={item.supplierId} 
                    value={item.supplierName} 
                    data-supplierId = {item.supplierId}
                    selected = {copyPrework?.attemptdata?.finalSelectedSupplier == item?.supplierId}
                    aria-label={item.supplierName}
                    >
                      {item.supplierName}
                    </option>)
                  }
                </select> */}
              {/*SP*/}
                <label htmlFor="supplierDropdown"><strong>Top Supplier Choice: </strong></label>
                <select id="supplierDropdown" className={`supplier-dropdown ${ScmModuleStyle["supplier-dropdown"]}`} disabled={copyPrework?.completed || !(copyPrework?.mode == "do" || copyPrework?.mode == "preview") || (activity1TotalWeightedScore != 1) || (activity1CriteriaMatched.length < 4)}>
                  <option value="" selected={!(copyPrework?.attemptdata?.finalSelectedSupplier)} disabled>Select</option>
                  {
                    copyPrework?.attemptdata?.suppliers && Object.values(copyPrework?.attemptdata?.suppliers)?.map((item, i) => 
                    <option 
                    key={item.supplierId} 
                    value={item.supplierName} 
                    data-supplierId = {item.supplierId}
                    selected = {copyPrework?.attemptdata?.finalSelectedSupplier == item?.supplierId}
                    aria-label={item.supplierName}
                    >
                      {item.supplierName}
                    </option>)
                  }
                </select>
                {
                    copyPrework?.completed ? 
                    // ( (copyPrework?.attemptdata?.finalSelectedSupplier && copyPrework?.attemptdata?.finalSelectedSupplier == getMaxWeightedSupplier())
                    ( (copyPrework?.attemptdata?.finalSelectedSupplier && getMaxWeightedSupplier().includes(copyPrework?.attemptdata?.finalSelectedSupplier))
                    ? <span className={`${ScmModuleStyle["correct-sign"]}`}>
                    <span className="sr-only">correct supplier</span>
                    </span>
                    : <span className={`${ScmModuleStyle["incorrect-sign"]}`}>
                      <span className="sr-only">incorrect supplier</span>
                    </span>
                      ) 
                      : ""
                }
                </div>
                
              </div>
            </div>
        </div>
        {
          
                  !prework?.completed ?
                  <div className={`${ScmModuleStyle["save-submit-block"]}`}>
                  <Button 
                  btnClass={`title ui label`}   
                  clickEventHandler={()=>{
                    setIsSave(true);
                    isToActivateToaster.current = true;
                  }} 
                  customBtnStyle={{
                    pointerEvents: (isRequestLoading || prework?.completed) ? 'none' : 'auto',
                    zIndex: 1,
                    width: '80px',
                    cursor: 'pointer',
                    marginLeft: '0px'
                  }}
                  disabled={isRequestLoading || prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")}
                  btnName={"Save"}
                  btnParentStyle={{display:"inline-block"}}
                />

                <Button 
                  btnClass={`title ui label`}   
                  clickEventHandler={submitPrework} 
                  customBtnStyle={{
                    pointerEvents: (isRequestLoading || prework?.completed) ? 'none' : 'auto',
                    zIndex: 1,
                    width: '90px',
                    cursor: 'pointer',
                    marginLeft: '0px'
                  }}
                  disabled={isRequestLoading || prework?.completed || !(prework?.mode == "do" || prework?.mode == "preview")}
                  btnName={"Submit"}
                  btnParentStyle={{display:"inline-block"}}
                />
                {
                  isSubmitMsg ? <div className={`ui message ${ScmModuleStyle.ui} ${ScmModuleStyle.message}`}>
                    <div role='alert'>
                      { 
                        <><img src={info1} height={22}/>
                        <p style={{marginTop:"0px"}}>{`Total Weight Score should be 1.0.`}</p>
                        </>
                      }
                    </div>
                  </div>
                  : ""
                }
                </div>
                : ""
                }
              
        <div id="saveToaster" role="alert" className={`ui message ${ScmModuleStyle['save-toaster']}`} style={{"display": "none"}}>
          <p>Your data is saved, to complete activity please click on Submit.</p>
        </div>
        {
                  (prework?.completed && prework?.hasOwnProperty('score')) ?
                  <div className={`${ScmModuleStyle["score-container"]}`}>
                      <div className={`${ScmModuleStyle["score-div"]}`} id="preworkScoreBlock">
                          Score: {copyPrework?.score}% ({copyPrework?.score}/{100} points)
                      </div>
                      <div className={`${ScmModuleStyle["completionbar"]}`}>Click 
                      <Button 
                        btnClass={`title ui label`}   
                        clickEventHandler={resetPrework} 
                        customBtnStyle={{
                          pointerEvents: (isRequestLoading) ? 'none' : 'auto',
                          zIndex: 1,
                          cursor: 'pointer',
                          marginLeft: '20px',
                          width: '75px',
                          opacity: (isRequestLoading) ? 0.5 : 1,
                          margin: "3px 8px",
                          marginLeft : "8px"
                        }}
                        // btnParentStyle={{display:"inline-block"}}
                        btnParentStyle={{display:"block"}}
                        btnName={"Retry"}
                        disabled={!(prework?.mode == "do" || prework?.mode == "preview")}
                      />
                        to attempt again <strong>(remaining attempts: {copyPrework?.remattempt})</strong>. Click 
                        <Button 
                        btnClass={`title ui label`}   
                        clickEventHandler={handlePopupExitSim} 
                        customBtnStyle={{
                          zIndex: 1,
                          cursor: 'pointer',
                          marginLeft: '20px',
                          width: '75px',
                          margin: "3px 8px",
                          marginLeft : "8px"
                        }}
                        // btnParentStyle={{display:"inline-block"}}
                        btnParentStyle={{display:"block"}}
                        btnName={"Close"}
                      />
                          to exit.</div>
                  </div>
                  : ""
        }
      </div>
    </div>

  );
};
export default Prework;
